var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_201_4557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0C9.3832 0 4 5.3832 4 12V16.9716C4 18.2004 5.0764 19.2 6.4 19.2H7.6C7.91826 19.2 8.22348 19.0736 8.44853 18.8485C8.67357 18.6235 8.8 18.3183 8.8 18V11.8284C8.8 11.5101 8.67357 11.2049 8.44853 10.9799C8.22348 10.7548 7.91826 10.6284 7.6 10.6284H6.5104C7.1776 5.9844 11.1736 2.4 16 2.4C20.8264 2.4 24.8224 5.9844 25.4896 10.6284H24.4C24.0817 10.6284 23.7765 10.7548 23.5515 10.9799C23.3264 11.2049 23.2 11.5101 23.2 11.8284V19.2C23.2 20.5236 22.1236 21.6 20.8 21.6H18.4V20.4H13.6V24H20.8C23.4472 24 25.6 21.8472 25.6 19.2C26.9236 19.2 28 18.2004 28 16.9716V12C28 5.3832 22.6168 0 16 0Z",
    fill: "#239EC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.01548 10.5573L5.93343 11.1284H6.5104H7.6C7.78565 11.1284 7.9637 11.2022 8.09497 11.3334C8.22625 11.4647 8.3 11.6427 8.3 11.8284V18C8.3 18.1857 8.22625 18.3637 8.09497 18.495C7.9637 18.6263 7.78565 18.7 7.6 18.7H6.4C5.31699 18.7 4.5 17.89 4.5 16.9716V12C4.5 5.65934 9.65934 0.5 16 0.5C22.3407 0.5 27.5 5.65934 27.5 12V16.9716C27.5 17.89 26.683 18.7 25.6 18.7H25.1V19.2C25.1 21.5711 23.1711 23.5 20.8 23.5H14.1V20.9H17.9V21.6V22.1H18.4H20.8C22.3997 22.1 23.7 20.7997 23.7 19.2V11.8284C23.7 11.6427 23.7738 11.4647 23.905 11.3334C24.0363 11.2022 24.2143 11.1284 24.4 11.1284H25.4896H26.0666L25.9845 10.5573C25.2826 5.67181 21.0798 1.9 16 1.9C10.9202 1.9 6.71738 5.67181 6.01548 10.5573Z",
    stroke: "#239EC2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_201_4557",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_201_4557"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_201_4557",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.9ecf365411347141a3125cd7853fa5d2.svg";
export { ForwardRef as ReactComponent };